import { useMutationWithErrorModal } from 'components/Wizards/MultiStepBlogPostWizard/useMutationWithErrorModal'
import { useOutline } from 'components/Wizards/MultiStepBlogPostWizard/OutlineProvider'

interface Props {
  onCancel?: () => void
}

export const useGenerateOutline = ({ onCancel }: Props) => {
  const { generateOutline } = useOutline()

  return useMutationWithErrorModal(generateOutline, { onCancel })
}
